import pulse from '@finn-no/pulse-sdk';
import { IconCheck16 } from '@warp-ds/icons/react/check-16';
import { IconLinkExternal16 } from '@warp-ds/icons/react/link-external-16';
import { Box, Button } from '@warp-ds/react';
import type React from 'react';
import { NettbilLogo } from './NettbilLogo.js';

export const NettbilBox: React.FC = () => {
  const trackClick = () => {
    pulse.trackEvent({
      name: 'Read more about Nettbil',
      type: 'Click',
      intent: 'Open',
      object: {
        type: 'UIElement',
        elementType: 'Button',
        id: 'nettbilBtn',
      },
      target: {
        type: 'Page',
        pageType: 'product_description',
        name: 'FINN.no samarbeider med Nettbil!',
        id: 'nettbil.no/finn',
      },
      vertical: {
        name: 'mobility',
      },
    });
  };

  return (
    <>
      <Box bordered className="flex flex-col justify-between h-full">
        <div className="md:mb-16 flex-grow">
          <div className="mb-24">
            <NettbilLogo />
          </div>
          <h2 className="h3 mb-8 flex items-center">La Nettbil selge for deg</h2>
          <p className="h4 mb-16">Du blir kvitt bilen raskt og enkelt, mot en litt lavere pris for bilen.</p>
          <p className="mb-24">
            Nettbil legger ut bilen din på budrunde hvor over 2 000 bilforhandlere har mulighet til å by på bilen din.
            Hvis du godtar det høyeste budet er bilen solgt, og du har penger på konto innen et par dager.
          </p>
          <div className="flex-col">
            <div className="flex cols-2 items-center mb-8">
              <IconCheck16 className="s-icon-positive mr-8" />
              Veldig raskt bilsalg
            </div>
            <div className="flex cols-2 items-center mb-8">
              <IconCheck16 className="s-icon-positive mr-8" />
              Slipp reklamasjonsansvaret
            </div>
            <div className="flex cols-2 items-center mb-8">
              <IconCheck16 className="s-icon-positive mr-8" />
              Kostnadsfri og uforpliktende budrunde
            </div>
          </div>
        </div>
        <div className="mt-auto mb-16">
          <Button
            href="https://www.nettbil.no/finn?utm_source=finn&utm_medium=affiliate&utm_campaign=adin"
            fullWidth
            onClick={trackClick}
          >
            Fortsett med Nettbil
            <IconLinkExternal16 className="ml-8 inline align-text-top" />
          </Button>
        </div>
        <p className="text-12 mt-4">
          Nettbil tar et mellomlegg på mellom 5 000 og <span className="whitespace-nowrap">19 000 kr</span>, avhengig av
          bilens verdi. Mellomlegget dekker blant annet kostnader for test, annonsering, budrunde og reklamasjonsansvar
          etter salg.
        </p>
      </Box>
    </>
  );
};
